import { render, staticRenderFns } from "./ProductSpecificationMain.vue?vue&type=template&id=1bfa8f32"
import script from "./ProductSpecificationMain.vue?vue&type=script&lang=js"
export * from "./ProductSpecificationMain.vue?vue&type=script&lang=js"
import style0 from "./ProductSpecificationMain.vue?vue&type=style&index=0&id=1bfa8f32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports